import { Box } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

export const formLabel = (theme: Theme) => ({
  color: theme.palette.text.secondary,
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '16px',
  letterSpacing: '-0.28px',
});

export const FormControllerTitle = styled(Box)(({ theme }) => ({
  ...formLabel(theme),
  marginBottom: '8px',
}));

export const TaInputSize = (theme: Theme) => ({
  maxWidth: '324px',
  width: '100%',
  marginBottom: '16px',
  height: '32px',
  boxShadow: theme.colors?.shadows.inputs,
  borderRadius: theme.borderRadius?.borderRadiusSmall,
  '& .MuiInputBase-root, &.MuiInputBase-root': {
    height: '32px',
    border: 'none',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
  },
  '.MuiOutlinedInput-notchedOutline': { border: 0 },
  '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
});
